<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>

     <div class="mt-1 full-width container font">
     <p v-show="error">{{ error }}</p>   
   
         <div>
         
        <div class="mt-1 ">
          <div class="row d-flex justify-content-center" v-if="notes.length>0">
          <div v-for="(note, index) in notes" :key="index" class="m-1 col-auto card">
           
            <div class="d-flex justify-content">
              <div>
                    <img :src="note.cover" class="img" v-if="note.cover!=undefined && note.cover!=''">
                    <div v-else>
                      <img :src="note.imgs[0]" class="img" v-if="note.imgs!=undefined && note.imgs.length>0">
                    </div>
                    <div v-if="note.video!=undefined">
                      <a  :href="note.video" target="blank">视频</a>
                    </div>
                    
                    <br>
                    <div class="m-1">
                    <div>{{ note.title }}</div>               
                    <div>计划发送：{{ formatDate(note.send_day) }} {{ note.send_time }}</div>
                    <div v-if="note.user_info!=undefined">账号名称：{{ note.user_info.nickname}}</div>
                    <div class="d-flex justify-content-between mt-1">
                      <router-link :to="`/admin/detail/${note.objectId}`">
                    <div >查看</div>
                  </router-link>
                    
                        <a v-if="note.hot_note_id!=undefined" :href="`https://www.xiaohongshu.com/explore/${note.hot_note_id}?xsec_token=AB7M6ABG8F3iLr9-fxcLuffhtUa_FswmsXcRRsKf3z9WA=&xsec_source=pc_feed`" target="blank">原帖</a>

                       
                        <div class="backBtn mr-1" v-if="note.cancel!=true" @click="cancel(note)">取消发送</div>
                        <div v-if="note.cancel==true">已经取消</div>
                    </div>
                  </div>
               </div>
               <div>
               
               </div>  
               <!-- </div>
               </div>
            </div> -->
            
                    
              </div>
        </div>
      </div>
        </div>

        <div class="mt-1 mb-1 d-flex justify-content" v-if="totalPage>0">
          <div v-for="(n,index) in totalPage" :key="index">
            <div :class="n==page?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n)">
              {{ n }}
            </div>
            
          </div>

        </div>
            
    
         </div>
   
      
     </div>
   </template>
   
   <script>
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   import axios from 'axios';
   import moment from 'moment'

   
   export default {
     data(){
       return {
         isLoading:false,
         keyword:'',
         error:'',
         accountId:'',
         account:null,
         users:[],
         notes:[],
         spinnerColor:"#262626",
         text:'test\ntest',
         page:1,
         count:10,
         totalPage:1,
         canceling:false,
         isView:false,
         selectedNoteId:null


       }
       
     },
     computed: {
     
     formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     }


   },
   
     components: {
      GridLoader,
   
     },
      setup(){
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
        
     },
   
   
     created(){
      console.log('refresh')
      var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('/')
          return
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
       this.accountId = this.$route.params.id;

      this.getPages()
      
    
     },
     methods:{
      

        async cancel(note){
         try{
            if (window.confirm("确定要删除吗?")) {

            this.isLoading=true;
            var id=note.objectId
           const response = await axios.get(this.domain+'xhs/cancel_send_note?note_id='+id);
          
           var data=response.data
           if(data['status']=='Suc')
           {
            
                note.sent=true;
                note.cancel=true;
                console.log('suc')
              
           }
           else
           {
               console.error(data)
               
           }
        }
         }
         catch(error)
         {
             console.error(error)
         }
         finally{
          this.isLoading=false
         }
       },
   
       async getPages(){
         try{
          console.log('get pages')
           
           const response = await axios.get(this.domain+'xhs/get_users_count');
          
           var data=response.data
           console.log(data)
           if(data['status']=='Suc')
           {
              
               var count=data['count']
               this.totalPage=Math.ceil(count/this.count)
               this.page=1
               this.getNotes()
              
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
       
       },

       changePage(n){
        if(n==this.page)
        {
          return
        }
        this.page=n
        this.getNotes()
       },
        async getNotes(){
         try{
            this.isLoading=true
            const response = await axios.get(this.domain+'xhs/get_notes?page='+(this.page-1)+'&count='+this.count);
          
           var data=response.data
           console.log(data)
           if(data['status']=='Suc')
           {
               this.notes=data['users']  
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },
     }
      
     
   };
   </script>
<style scoped>

.img{
    width:3.5rem;
    border-radius: 0.125rem, 0.125rem,0 0;
}

.card{
  height:max-content;
  min-width: 3rem;
  max-width: 4rem;
}

.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.account_icon{
  width:0.5rem;
  height:0.5rem;
  border-radius: 50%;
}


</style>
   
   